import { registerPlugin } from '@capacitor/core';

import type { CoreMidiPlugin } from './definitions';

const CoreMidi = registerPlugin<CoreMidiPlugin>('CoreMidi', {
  web: () => import('./web').then(m => new m.CoreMidiWeb()),
});

export * from './definitions';
export { CoreMidi };